import {AclFilterChip} from "../listpage/FilterRenderer";
import {facetToFilterGroup} from './Util';

import renderFilterForm from './templates/factfinder-filter-form.tpl.html';

const EN = window.EN;

class FactfinderFacetFilter {

	constructor( containerEl ) {
		this.containerEl = containerEl;
	}

	async update( {facets: unsortedFacets, sortItems, searchParams} ) {

		const selectedFacets = unsortedFacets.filter( facet => ( facet.selectedElements || [] ).length > 0 );
		const defaultFacets = unsortedFacets.filter( facet => ( facet.selectedElements || [] ).length <= 0 );

		const facets = [ ...selectedFacets, ...defaultFacets ];

		// Render Facet Filters.
		const dummyContainerEl = document.createElement( 'div' );
		dummyContainerEl.innerHTML = await EN.Render.render( 'factfinder-filter-form', { facets, sortItems } );

		const filterItemEls = Array.from( dummyContainerEl.querySelectorAll( '.mdl_filter__item' ) );
		facets.forEach( facet => {
			const chipEls = filterItemEls.filter( facetEl => facetEl.dataset.identifier === facet.associatedFieldName );
			chipEls.forEach( chipEl => {
				chipEl.ACL_FILTER_CHIP ??= new FactfinderFilterChip( chipEl, facet, searchParams );
			} )
		} );

		this.containerEl.querySelector( '.mdl_filter__list' ).replaceWith( dummyContainerEl.firstElementChild );
	}
}

class FactfinderFilterChip extends AclFilterChip{

	constructor( chipEl, facet, searchParams ) {
		super( chipEl );
		this.facet = facet;
		this.searchParams = searchParams;
	}

	getFilterGroup( identifier, facet ) {
		return facetToFilterGroup( facet );
	}

	async renderChip( customFilterJSON = null, mode = null ) {
		return super.renderChip( customFilterJSON || this.facet, mode );
	}

	submitChip() {
		this.onSubmit();
	}

	onSubmit() {
		let searchParams = {
			...this.searchParams
		};
		searchParams.filters ??= [];

		const identifier = this.getIdentifier();
		const filterGroup = this.getFilterGroup( identifier, this.facet );

		if ( 'pricerange' === filterGroup.type ) {
			const [filter] = filterGroup.filter;
			const elements = this.getFieldset().elements;

			const absMinVal = elements['price[min]'].value;
			const absMaxVal = elements['price[max]'].value;

			const currMinVal = elements['price[from]'].value;
			const currMaxVal = elements['price[to]'].value;

			if ( absMinVal === currMinVal && absMaxVal === currMaxVal ) {
				// Remove current filter from searchParams.
				searchParams.filters = searchParams.filters.filter( ( filter ) => filter.name !== identifier );
			} else {
				// Add Filter to searchparams.
				searchParams = {
					...filter.data.searchParams,
					filters: [
						...( filter.data.searchParams.filters || [] ),
						{
							name: filterGroup.identifier,
							substring: false,
							values: [{
								exclude: false,
								type: 'or',
								value: `[${parseFloat( currMinVal )}, ${parseFloat( currMaxVal )})`,
							}]
						}
					]
				}
			}

		} else {
			const selectedEls = Array.from( this.getFieldset().elements ).filter( inputEl => inputEl.checked ).map( inputEl => inputEl.id );

			const selectedFilters = filterGroup.filter.filter( ( element ) => selectedEls.includes( element.filterId ) ).map( ( {data} ) => data.searchParams );
			const unselectedFilters = filterGroup.filter.filter( ( element ) => element.selected && ! selectedEls.includes( element.filterId ) ).map( ( {value} ) => value );

			searchParams = selectedFilters.reduce( ( prev, curr ) => {
				const filters = prev.filters || [];
				( curr.filters || [] ).forEach( currFilter => {
					const index = filters.findIndex( ( {name} ) => name === currFilter.name );
					if ( index !== -1 ) {
						const prevFilter = prev.filters[ index ];
						filters[ index ].values = [ ...prevFilter.values, ...currFilter.values ];
					} else {
						filters.push( currFilter );
					}
				} );

				return {
					...prev,
					...curr,
					filters: filters
				}
			}, searchParams );

			searchParams.filters = searchParams.filters.map( ( filter ) => {
				if ( filter.name !== identifier ) {
					return filter;
				}

				const values = filter.values.filter( ( {value} ) => ! unselectedFilters.includes( value ) ).filter( ( {value}, index, array ) => array.findIndex( ( inner ) => inner.value === value ) === index );
				if ( values.length <= 0 ) {
					return null; // Disable this filter.
				}

				return {
					...filter,
					values
				}
			} ).filter( f => !! f );
		}

		searchParams.page = 1;

		// Dispatch Submit to Controller.
		this.chipEl.dispatchEvent( new CustomEvent( 'change.ff', { bubbles: true, detail: { searchParams } } ) );
		this.choiceUpdated = false;
		this.close();
	}
}

// Add Render Template.
EN.Render.addTemplate( 'factfinder-filter-form', renderFilterForm );

export default FactfinderFacetFilter;
